import React from "react";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";
import {Intro} from '../components/ecosystem/Intro';
import {Faq} from '../components/ecosystem/Faq';
import {Subscribe} from "../components/global/Subscribe";
import {graphql} from "gatsby";
import {Solutions} from "../components/ecosystem/Solutions";

const EcosystemPage = (props) => {
  const acf = props.data.page.template.ecosystemPageACF || {};
  const partners = props.data.partners || {};
  const categories = props.data.categories || {};

  const translations = props?.data?.page?.translations || {}
  return (
    <Layout translations={translations}>
      <Intro data={acf.intro} />
      <Solutions data={acf.about} items={partners} categories={categories} link={acf.intro?.link || {}}/>
      <Faq data={acf.faq} />
      <Subscribe number={`04.`} color={'purple'}/>
    </Layout>
  );
};

export default EcosystemPage;
export const pageQuery = graphql`
  query ($lng: String!, $id: Int!) {
    locales: allLocale(
      filter: { language: { eq: $lng } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    categories : allWpPartnerCategory(filter: {language: {slug: {eq: $lng}}}) {
      nodes {
          parentId : parentDatabaseId
          id : databaseId
          name
      }
    }
    partners : allWpPartner(filter: {language: {slug: {eq: $lng}}}, sort: {date: ASC}) {
      edges {
        node {
          acf : partnerACF {
            link
            socials {
              twitter
              github
              discord
            }
            text
            token
          }
          title
          image : featuredImage {
            node {
              localFile {
                publicURL
              }
            }
          }
          category : partnerCategories {
            nodes {
              id : databaseId
            }
          }
        }
      }
    }
    page : wpPage(language: {slug: {eq: $lng}}, databaseId: { eq: $id }) {
      seo {
        metaDesc
        opengraphDescription
        opengraphTitle
        title
      }
      translations {
        slug
      }
      title
      template {
        ... on WpTemplate_Ecosystem {
          ecosystemPageACF {
            about {
              title
              text
              suptitle
              number
            }
            intro {
              number
              text
              titlePart0
              titlePart1
              titlePart3
              titlePart2
              link {
                target
                title
                url
              }
            }
            faq {
              title
              suptitle
              number
              items {
                title
                text
              }
            }
          }
        }
      }
    }
  }
`;

export const Head = (props) => {
  const seo = props.data.page?.seo || {}
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
}
